import { usePaginationParams } from 'hooks';
import { UploadList } from '../component/transaction-table-list/upload-list';
import { useGetBulkUploadList } from '../use-cases/get-bulk-upload-list';
import { UploadFilterForm } from '../component/upload-filter-form/upload-filter-form';
import { ContentFilters } from 'components';
import {
  UploadFilterFormField,
  UploadFilterFormValuesPaginated,
} from '../component/upload-filter-form/types';
import { useState } from 'react';
import { GroupRegistrationModal } from '../modal/group-registration-modal';
import { UploadListTopBar } from '../component/top-bar/upload-list-bar';
import { Button } from 'antd';
import { FileExcelOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import { useUserContext } from 'features/users';
import { getPermission } from 'routes/utils';

export const UploadListView = () => {
  const formId = 'upload-list-filter';

  const [grp, setGRP] = useState<boolean>(false);
  const [modalType, setModalType] = useState<string>("Gropu Registration");
  const location = useLocation()

  const getInitialFilterValues = {
    [UploadFilterFormField.GroupId]: undefined,
    [UploadFilterFormField.GroupName]: undefined,
    [UploadFilterFormField.Phone]: undefined,
    [UploadFilterFormField.Email]: undefined,
    [UploadFilterFormField.EventId]: undefined,
    [UploadFilterFormField.Flag]: "admin",
  };
  const { user } = useUserContext();
  const GroupRegsitraionPerm = getPermission(user, "group_registration");
  const Registrion = GroupRegsitraionPerm?.print; // true / false


  const { params, updateParams, resetPage } = usePaginationParams<any>({
    // Flag: 'admin',
    Origin: 'Null',
    page: 1,
    size: 10,
    AgentId: user?.user_id,
    ...getInitialFilterValues
  });
  //  const updatedFlag: string | undefined = location.pathname.includes(
  //   '/group-registration-List',
  // )
  //   ? 'GroupRegistration'
  //   : undefined;
  const updatedTitle: string | undefined = location.pathname.includes(
    '/group-registration-List',
  )
    ? 'Group Registration & Bulk Upload'
    : 'Bulk Upload List';
  const { data, refetch, isFetching } = useGetBulkUploadList(params);
  const handleFiltersChange = (values: UploadFilterFormValuesPaginated) => {

    updateParams(values);
    resetPage();
    refetch();
  };
  const closeParticipantModal = () => {
    setGRP(false);
    setModalType("");
    document.body.style.overflow = 'visible';
  }
  const openGRModal = (val: string) => {
    setGRP(true);
    setModalType(val);
    document.body.style.overflow = 'hidden';
  }

  return (
    <>
      <div className={`cstmrightmdl ${grp && "show"}`}>
        <GroupRegistrationModal
          closeModal={closeParticipantModal}
          isOpen={grp}
          modalType={modalType}
        />
      </div>
      <div className='grp_head' style={{ marginBottom: "10px" }}>
        <UploadListTopBar updatedTitle={updatedTitle} />
        {Registrion &&(
        <Button
          icon={<FileExcelOutlined />}
          onClick={() => openGRModal("GroupRegistrationReport")

          }
          type='primary'
        // loading={loading}
        >
          Group Registration Report
        </Button>
        )}

      </div>
      <ContentFilters formId={formId}>
        <UploadFilterForm
          formId={formId}
          handleFilter={handleFiltersChange}
          initialValues={getInitialFilterValues as any}
        />
      </ContentFilters>

      <UploadList
        isSocialListLoading={isFetching}
        DeliveryList={data}
        tableParams={params as any}
        updateParams={updateParams}
        refetch={refetch}
        updatedFlag={'' as any}
      />
    </>
  );
};
